<app-whitepaper-article-hero [pageData]="pageData"></app-whitepaper-article-hero>
<app-whitepaper-article-apply [pageData]="pageData"></app-whitepaper-article-apply>
<app-whitepaper-article-re-report [pageData]="pageData"></app-whitepaper-article-re-report>
<!-- <app-whitepaper-article-getstarted></app-whitepaper-article-getstarted> -->

<!-- <app-common-getstarted [getStartedData]="getStartedData"></app-common-getstarted> -->
